export default __webpack_public_path__ + "static/maremailcase2-7a9ac8d9e9eb3d75f74b07681b6bac19.png";